import { Injectable } from '@angular/core';
import { CacheStorage as CacheStorageBase, CacheStorageService } from '@skylab-shared/core';
import { Wrapper } from '../wrapper/wrapper';

export { CacheStorageBase };

@Injectable({ providedIn: 'root' })
@Wrapper(CacheStorageService, { static: true })
export class CacheStorage { }
